import React from "react";

import { PanelWithHeader } from "../panels/PanelWithHeader";
import { TasksSummary } from "../todo/TasksSummary";
import { BodyWeightChart } from "../lifestyle/BodyWeightChart";
import { QuickLoansStatistics } from "../loans/QuickLoansStatistics";
import { QuickShoppingList } from "../shopping/QuickShoppingList";

import { PanelWithBreadCrumbAndSearchBox } from "../panels/PanelWithBreadCrumbAndSearchBox";

type HouseHomePageProps = {
  value: string;
};

export const HouseHomePage = (props: HouseHomePageProps) => {
  return (
    <div className="container-fluid mt-3">
      <PanelWithBreadCrumbAndSearchBox currentPageName="Dashboard" />
      {/* <-- ~Heading --> */}

      <div className="row wow fadeIn">
        <div className="col-lg-9 col-md-6 mb-4">
          <PanelWithHeader
            header="LifeStyle / Vývoj váhy"
            iconClassName="fas fa-running"
          >
            <BodyWeightChart
              weightRows={[
                { date: "1.1.2020", weight: 108.1 },
                { date: "2.1.2020", weight: 106.9 },
                { date: "3.1.2020", weight: 101.9 },
                { date: "4.1.2020", weight: 102.4 },
                { date: "5.3.2020", weight: 98.2 },
              ]}
            />
          </PanelWithHeader>
        </div>

        <div className="col-lg-3 col-md-6 mb-4">
          <PanelWithHeader header="Seznam úkolů" iconClassName="fas fa-tasks">
            <TasksSummary completed={47} inProgress={6} notStarted={22} />
          </PanelWithHeader>
        </div>

        <div className="col-lg-6 col-md-6 mb-4">
          <PanelWithHeader
            header="Dlužníček"
            iconClassName="fas fa-search-dollar"
          >
            <QuickLoansStatistics />
          </PanelWithHeader>
        </div>

        <div className="col-lg-6 col-md-6 mb-4">
          <PanelWithHeader
            header="Nákupní seznam"
            iconClassName="fas fa-shopping-cart"
          >
            <QuickShoppingList />
          </PanelWithHeader>
        </div>
      </div>
    </div>
  );
};
